import { apiClient } from "./useApi"
import { ApiTag } from "./util/ApiTag"
import { McoEndpointBuilder } from "./apiSlice"

const patientConditionEndpoints = (build: McoEndpointBuilder) => ({
	patientConditionChange: build.mutation({
		queryFn: apiClient.patient.condition.changeProblemArea,
		invalidatesTags: (_, __, { patientConditionUuid }) => [
			ApiTag.Tenant,
			{ type: ApiTag.PatientCondition, id: patientConditionUuid }
		]
	}),
	patientConditionActivate: build.mutation({
		queryFn: apiClient.patient.condition.activate,
		invalidatesTags: (_, __, patientConditionUuid) => [
			ApiTag.Tenant,
			{ type: ApiTag.PatientCondition, id: patientConditionUuid }
		]
	}),
	patientConditionArchive: build.mutation({
		queryFn: apiClient.patient.condition.archive,
		invalidatesTags: (_, __, patientConditionUuid) => [
			ApiTag.Tenant,
			{ type: ApiTag.PatientCondition, id: patientConditionUuid }
		]
	}),
	patientConditionUpdate: build.mutation({
		queryFn: apiClient.patient.condition.update,
		invalidatesTags: (_, __, { patientConditionUuid }) => [
			ApiTag.Tenant,
			{ type: ApiTag.PatientCondition, id: patientConditionUuid }
		]
	})
})

export default patientConditionEndpoints
